import { useCallback } from 'react';
import { useRoutesContext } from '../';

export const useUnactiveRoutes = () => {
  const { routes } = useRoutesContext();

  const unactiveRoutes = useCallback(() => {
    routes?.forEach(route => {
      route.selectRoute(false);
    });
  }, [routes]);

  return unactiveRoutes;
};


